import { DashboardMenuOption } from 'components/dashboard-menu/constants'
import {RasaLogo} from 'components/icons/rasalogo'
import { RasaBrowserComponent } from 'generic/rasaBrowserComponent'
import React from 'react'
import * as ReactStrap from 'reactstrap'
import { ERROR_TYPE_QUERY, HandledPageErrorType } from './constants'
import * as GlobalConstants from '../../constants'
import { loadPartnerConfiguration, applyPartnerConfig } from '../../app/utils'
import './_styles.scss'

const {Col, Row} = ReactStrap

export class HandledErrorPageComponent extends RasaBrowserComponent<any, any> {
  constructor(props: any) {
    super(props, { partnerConfig: null })
  }

  public componentDidMount() {
    loadPartnerConfiguration()
      .then((config) => {
        this.setState({ partnerConfig: config })
        applyPartnerConfig(config)
      })
  }

  public render() {
    return (
      <div className="handled-error-page">
        <div className="dashboard-menu">
          <div className={'dashboard-menu-item dashboard-rasa-logo'}
            onClick={() => this.handleLogoClick()}>
            {this.renderLogo()}
          </div>
          <div className="help-links-container">
            {this.state.partnerConfig && this.state.partnerConfig.COMMUNITY_URL && this.state.partnerConfig.COMMUNITY_URL.length &&
            <div className="dashboard-popup-menu-item clickable-item need-a-help">
              <a href={this.state.partnerConfig.COMMUNITY_URL} target="_blank" rel="noopener">{GlobalConstants.RASA_COMMUNITY_LABEL}</a>
            </div>
            }
            <div className="dashboard-popup-menu-item clickable-item need-a-help">
              <a href={this.state.partnerConfig && this.state.partnerConfig.HELP_URL ? this.state.partnerConfig.HELP_URL : GlobalConstants.RASA_HELP_BASE_URL} target="_blank" rel="noopener">Help & Support</a>
            </div>
          </div>
        </div>
        <Row className="page-wrapper">
          <Col md="6" lg="12" className="content">
            <h1>{this.getHeader()}</h1>
            <p className="enter-paragraph">{this.getContent()}</p>
          </Col>
        </Row>
      </div>
    )
  }

  private getHeader() {
    const errorType = this.getQuery(ERROR_TYPE_QUERY) || HandledPageErrorType.UNKNOWN
    switch (errorType) {
      case HandledPageErrorType.NO_NEWSLETTER:
        return 'No Newsletter'
      case HandledPageErrorType.ACCOUNT_SUSPENDED:
        return 'Account Suspended'
      default:
        return 'Unknown Error!'
    }
  }
  private getContent() {
    const errorType = this.getQuery(ERROR_TYPE_QUERY) || HandledPageErrorType.UNKNOWN
    switch (errorType) {
      case HandledPageErrorType.NO_NEWSLETTER:
        return <div>
          You do not have access to any newsletter. If you think this is an error, please contact our <br></br>
          <a href={`${GlobalConstants.SUPPORT_EMAIL}?subject=No Newsletter}`}>Customer Support.</a>
        </div>
      case HandledPageErrorType.ACCOUNT_SUSPENDED:
        return <div>
          Your account has been suspended. Please contact our <br></br>
          <a href={`${GlobalConstants.SUPPORT_EMAIL}?subject=No Newsletter}`}>Customer Support.</a> for more details.
        </div>
      default:
        return <div>
          Oops, we couldn't recognise this error! Please contact our <br></br>
          <a href={`${GlobalConstants.SUPPORT_EMAIL}?subject=Unknown Error}`}>Customer Support.</a>
        </div>
    }
  }

  private handleLogoClick() {
    window.location.replace(DashboardMenuOption.dashboard)
  }

  private renderLogo(): JSX.Element {
    if (this.state.partnerConfig === null) {
      return null // wait until partnerConfig is loaded
    }
    
    if (this.state.partnerConfig && this.state.partnerConfig.WHITELABEL_LOGO_URL) {
      return <img src={this.state.partnerConfig.WHITELABEL_LOGO_URL} width="80" height="17.068"/>
    } else {
      return <RasaLogo/>
    }
  }
}
